// import { setLocation } from '@/utils/auth'
import config from '@/config/config.js'
import router from '@/router'
import jweixin from 'jweixin-module'
import { getWechatjssdk } from '@/api/user'

function userAgent ( agent ) {
  var userAgent = navigator.userAgent
  return userAgent.indexOf(agent) > -1
}

async function getGeoLocation () {
  const qqGeolocation = new qq.maps.Geolocation(
       config.GeoKeys,
       '客维测试'
  )
  return new Promise((resolve, reject) => {
    qqGeolocation.getLocation(
      position => {
            resolve(position)
          },
          err => {
            console.error('定位失败:', err)
            resolve('')
          }
    )
  })
}

async function getLocationByMinprogram () {
  const route = router.app._route
  // 获取小程序通信的信息
  if (route.query.miniprogram_data) {
    const info = JSON.parse(route.query.miniprogram_data)
    return info.location
  }
  // 向小程序发送获取位置信息
    uni.webView.postMessage({
      data: {
        data: {
          action: 'getLocation'
        },
        routerFrom: route.fullPath
      }
    })
  uni.navigateBack({
    delta: 1
  })
}

async function getLocationByjweixin () {
  const result = await getWechatjssdk()
  // if(result.data)
  if (result.data.data.status) {
    const jwxConfig = JSON.parse(result.data.data.config)
    wx.config({
      debug: jwxConfig.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
      appId: jwxConfig.appId, // 必填，公众号的唯一标识
      timestamp: jwxConfig.timestamp, // 必填，生成签名的时间戳
      nonceStr: jwxConfig.nonceStr, // 必填，生成签名的随机串
      signature: jwxConfig.signature, // 必填，签名
      jsApiList: jwxConfig.jsApiList, // 必填，需要使用的JS接口列表
      url: jwxConfig.url
    })
    
    wx.error(function(res) {
      console.log(res)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
    
    wx.ready(function () {
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          // console.log(res, 5555);
        }
      })
    })
  }
  return state
}

const state = {
  locationInfo: {
    accuracy: '',
    adcode: '',
    addr: '',
    city: '',
    district: '',
    lat: '',
    lng: '',
    module: '',
    nation: '',
    province: '',
    type: '',
    id: ''
  }
}

const mutations = {
  SET_LOCATION (state, info) {
    state.locationInfo = info
  },
  SET_CITY (state, city) {
    state.locationInfo.city = city.name
    state.locationInfo.id = city.id
  }
}

const actions = {
  setCity({ commit, state }, city) {
    commit('SET_CITY', city)
  },
  getLocationByMinprogram(commit, state) {
    getLocationByMinprogram
  },

  async getLocation({ commit, state }) {
     var map = new AMap.Map('container', {
       zoom: 12
     })
     console.log(map);
     
    // await getLocationByjweixin()
    // getLocationByjweixin()
    let position = ''

    if (
      userAgent('miniProgram') ||
      userAgent('miniprogram')
    ) {
      // position = await getLocationByMinprogram()
      position = {
        accuracy: 10000,
        adcode: 440106,
        addr: '',
        city: '广州市',
        district: '',
        lat: 23.12463,
        lng: 113.36199,
        module: 'geolocation',
        nation: '中国',
        province: '广东省',
        type: 'ip'
      }
    } else {
      position = await getGeoLocation()
    }

    commit('SET_LOCATION', position)
    return position
  },
  async searchLocation() {
    const result = await new TMap.service.Search({
      keyword: '广州'
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}